import Reporting from './Reporting.vue';
// import disable from './disable.vue';

export default Reporting;
